/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'

class GLRules extends React.Component {
	static propTypes = {
		title: PropTypes.string,
		array: PropTypes.array,
		sectionStyle: PropTypes.object,
		titleStyle: PropTypes.object,
	}

	static defaultProps = {
		title: '购买须知',
		array: [],
		sectionStyle: {},
		titleStyle: {},
	}

	render() {
		let title = this.props.title
		let array = this.props.array
		let sectionStyle = this.props.sectionStyle
		let titleStyle = this.props.titleStyle

		if (array.length === 0) {
			return null
		}

		return (
			<div className={CSS.section} style={sectionStyle}>
				<p className={CSS.sectionTitle} style={titleStyle}>
					{title}
				</p>
				<div className={CSS.sectionContent}>
					{array.map((item, index) => {
						if (_.isHasValue(item.value)) {
							return (
								<React.Fragment key={index}>
									<p className={CSS.sectionT}>{item.label || ''}</p>
									<p className={CSS.sectionC}>{item.value || ''}</p>
								</React.Fragment>
							)
						}
						return null
					})}
				</div>
			</div>
		)
	}
}

export default GLRules
